import * as Sentry from '@sentry/react';
import { call, takeEvery } from "redux-saga/effects";

import {
    ADD_MIXPANEL_EVENT,
} from "../actionTypes"

import {
    trackMixpanelService
} from "../../services/mixpanel"

import {
    
} from "../actions";

function* addMixpanelEventSaga(action){
    try {
        yield call(trackMixpanelService, action.payload);
    } catch (e) {
        Sentry.captureException(e);
    }
}

function* mixpanelSaga() {
    yield takeEvery(ADD_MIXPANEL_EVENT, addMixpanelEventSaga);
}

export default mixpanelSaga;
